import React, { useState, useEffect } from "react";

const messages = [
  "Made with pure 925 Sterling Silver",
  "Imported from Italy — Crafted in Karachi",
  "Zircon Jewels — The Royal Crown",
  "Royal designs. Everyday luxury.",
  "Jewelry that whispers elegance",
];

const Loader = () => {
  const [messageIndex, setMessageIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    // Message rotation with fade effect
    const messageInterval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
        setFade(true);
      }, 300); // Fade transition duration
    }, 2000); // Show each message for 2 seconds

    return () => clearInterval(messageInterval);
  }, []);

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '100%',
      backgroundColor: '#fff',
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: '20px',
      fontFamily: '"Playfair Display", serif',
      boxSizing: 'border-box',
    }}>
      <div className="loader-container" style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '500px', // Prevent content from stretching too wide
        margin: '0 auto',
      }}>
        {/* Logo/Brand Text with Shine Effect */}
        <div className="shine-wrapper" style={{
          marginBottom: '30px',
          width: '100%',
          position: 'relative',
          overflow: 'hidden', // Important for containing the shine effect
        }}>
          <div className="brand-name" style={{
            fontSize: 'clamp(24px, 5vw, 28px)', // Responsive font size
            fontWeight: '700',
            letterSpacing: '2px',
            color: '#1a1a1a',
            position: 'relative',
          }}>
            ZIRCON JEWELS
          </div>
        </div>
        
        {/* Loading Bar */}
        <div style={{
          width: '80%',
          maxWidth: '200px',
          height: '2px',
          backgroundColor: 'rgba(212, 175, 55, 0.2)',
          position: 'relative',
          overflow: 'hidden',
          marginBottom: '25px',
        }}>
          <div className="loading-progress" />
        </div>
        
        {/* Messages */}
        <p style={{
          color: '#666',
          fontSize: 'clamp(14px, 3.5vw, 16px)', // Responsive font size
          fontWeight: '400',
          width: '100%',
          lineHeight: '1.6',
          opacity: fade ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out',
          height: '26px',
          padding: '0 15px', // Add some padding on small screens
          boxSizing: 'border-box',
        }}>
          {messages[messageIndex]}
        </p>
      </div>
      
      {/* Footer information section - IMPROVED STYLING */}
      <div className="footer-info" style={{
        position: 'absolute',
        bottom: '30px',
        left: '0',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '10px',
        padding: '0 20px',
      }}>
        <div className="address" style={{
          color: '#8a8a8a',
          fontSize: 'clamp(12px, 2.5vw, 14px)',
          letterSpacing: '0.5px',
          fontWeight: '300',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
        }}>
          <span style={{ color: 'rgba(212, 175, 55, 0.8)' }}>•</span>
          Find our store at Hussain center, Zabunissa street, Saddar, Karachi
          <span style={{ color: 'rgba(212, 175, 55, 0.8)' }}>•</span>
        </div>
        <div className="social" style={{
          color: '#8a8a8a',
          fontSize: 'clamp(12px, 2.5vw, 14px)',
          letterSpacing: '1px',
          fontWeight: '400',
          display: 'flex',
          alignItems: 'center',
        }}>
          Follow us <span style={{ 
            fontWeight: '500', 
            marginLeft: '6px',
            background: 'linear-gradient(to right, #8a8a8a, rgba(212, 175, 55, 0.8))', 
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>@zircon___jewels</span>
        </div>
      </div>
      
      <style>{`
        .loading-progress {
          position: absolute;
          top: 0;
          left: 0;
          height: 100%;
          background: linear-gradient(90deg, rgba(212, 175, 55, 0.8), rgba(212, 175, 55, 1), rgba(212, 175, 55, 0.8));
          animation: loadingAnimation 2s infinite;
          width: 30%;
        }
        
        @keyframes loadingAnimation {
          0% {
            left: -30%;
          }
          100% {
            left: 100%;
          }
        }
        
        /* Brand name shine effect - slower and more subtle */
        .shine-wrapper::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 80%;
          height: 100%;
          background: linear-gradient(
            to right, 
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.1) 40%,
            rgba(255, 255, 255, 0.4) 50%,
            rgba(255, 255, 255, 0.1) 60%,
            rgba(255, 255, 255, 0) 100%
          );
          transform: skewX(-20deg);
          animation: shine 6s ease-in-out infinite;
          z-index: 1;
          pointer-events: none;
        }
        
        @keyframes shine {
          0% {
            left: -100%;
          }
          40% {
            left: 100%;
          }
          100% {
            left: 100%;
          }
        }
        
        /* Footer fade-in animation */
        .footer-info {
          animation: fadeIn 1.5s ease-in-out forwards;
          opacity: 0;
        }
        
        @keyframes fadeIn {
          0% { opacity: 0; transform: translateY(10px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default Loader;